__turbopack_context__.v({
  "avatar": "Header-module-scss-module__cakomG__avatar",
  "header": "Header-module-scss-module__cakomG__header",
  "headerNavLink": "Header-module-scss-module__cakomG__headerNavLink",
  "headerNavUtility": "Header-module-scss-module__cakomG__headerNavUtility",
  "hidden": "Header-module-scss-module__cakomG__hidden",
  "logoImage": "Header-module-scss-module__cakomG__logoImage",
  "logoWrapper": "Header-module-scss-module__cakomG__logoWrapper",
  "menuContainer": "Header-module-scss-module__cakomG__menuContainer",
  "menuContainerInner": "Header-module-scss-module__cakomG__menuContainerInner",
  "menuPanel": "Header-module-scss-module__cakomG__menuPanel",
  "slideToLeft": "Header-module-scss-module__cakomG__slideToLeft",
});
